module.exports = __webpack_public_path__ + "static/img/yycj_04.c649619.png";


//////////////////
// WEBPACK FOOTER
// ./src/comm/images/document-conversion/electronicDocuments/yycj_04.png
// module id = SPEg
// module chunks = 2